import React from 'react';

import Modal from 'ui-library/modals/Modal';

import {FeedbackContextItem} from './LLMFeedbackConstants';
import {LLMFeedbackFormContents, useFeedbackForm} from './LLMFeedbackFormContents';

export interface LLMFeedbackModalProps {
  /**
   * The title of the feedback modal
   */
  title: string;
  /**
   * Optional context items that the user can opt-out of including with their feedback
   */
  optionalContextItems: Array<FeedbackContextItem>;
  /**
   * Required context items that are not displayed to the user and always included with their feedback
   */
  requiredContextItems: Array<FeedbackContextItem>;
  onRequestClose: () => void;
}

export default function LLMFeedbackModal(props: LLMFeedbackModalProps): JSX.Element {
  const {disabled, submitForm, formProps} = useFeedbackForm(props);

  return (
    <Modal
      title={props.title}
      buttons={[{text: 'Submit feedback', submit: true, disabled}]}
      closeableOnBackgroundClick={true}
      closeableOnEscapeKey={true}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        submitForm().then(() => {
          // Only close on success: LLMFeedbackFormContents will show an error if the submission fails.
          props.onRequestClose();
        });
      }}
    >
      <LLMFeedbackFormContents isPositiveFeedback={false} {...formProps} />
    </Modal>
  );
}
